var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_91",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 1.09302H0V22.9978H22V1.09302Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_91)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04352 16.34C6.04352 14.2726 7.72678 12.5967 9.80319 12.5967C10.4956 12.5967 10.0794 12.5967 11.0587 12.5967C12.0379 12.5967 11.6051 12.5967 12.2975 12.5967C14.3831 12.5967 16.0738 14.28 16.0738 16.3565V16.9659H11.0587H6.04352V16.34Z",
    fill: "#00B4D7",
    stroke: "#404553",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 10.6509C12.385 10.6509 13.5077 9.53307 13.5077 8.15418C13.5077 6.77528 12.385 5.65747 11.0001 5.65747C9.61516 5.65747 8.49249 6.77528 8.49249 8.15418C8.49249 9.53307 9.61516 10.6509 11.0001 10.6509Z",
    fill: "#00B4D7",
    stroke: "#404553",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3957 12.0461C20.3957 17.2128 16.1891 21.4013 10.9999 21.4013C5.81073 21.4013 1.60406 17.2128 1.60406 12.0461C1.60406 9.71791 2.45733 7.58992 3.87036 5.95255C5.59456 3.9546 8.14864 2.69092 10.9999 2.69092C16.1891 2.69092 20.3957 6.87937 20.3957 12.0461Z",
    stroke: "#404553",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.56e9d6b67b917bd3eadca9dea055a1ed.svg";
export { ForwardRef as ReactComponent };